import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, CssBaseline, Dialog, Grid, IconButton, makeStyles, TextField } from '@material-ui/core';
// import { createMuiTheme } from '@material-ui/core/styles';
import { BarChart, Create, Delete } from '@material-ui/icons';
import SaveIcon from '@material-ui/icons/Save';
import MUIDataTable from 'mui-datatables';
import swal from '@sweetalert/with-react';
import moment from 'moment';
import Popout from 'react-popout-new';
import axiosInstance, { addComma, EVENT_ID, getEventId, saveDeadline, WEB_API } from '../constatns';
import AdminTopbar from './AdminTopbar';
import AdminFooter from './AdminFooter';
import ExhibiApplication from '../sponsor/ExhibiApplication';
import TableToolBarCustom from '../components/MuiDataTableCustom/TableToolBarCustom';
import TableFilterList from '../components/MuiDataTableCustom/TableFilterList';

import SponsorStatistics from './dialog/SponsorStatistics';
import { createTheme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 800,
    overflow: 'auto',
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiTableCell-root': {
      textAlign: 'center',
      fontSize: '13px',
      // minWidth: 100,
      '& span': {
        display: 'block',
        wordBreak: 'keep-all',
      },
      '& button': {
        fontSize: '13px',
      },
    },
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
}));

const SponsorListPage = (props) => {
  const { history } = props;
  const classes = useStyles();
  const [data, setData] = useState();
  const [alldata, setAllData] = useState();
  const [selectFilter, setSelectFilter] = useState('all');
  const [open, setOpen] = useState(false);
  const [openUrl, setOpenUrl] = useState('');
  const [openResend, setOpenResend] = useState(false);
  const [openUrlResend, setOpenUrlResend] = useState('');
  const [selectData, setSelectData] = useState(false);
  const [mode, setMode] = useState('');
  const [openChart, setOpenChart] = useState(false);
  const [count, setCount] = useState({});
  const EVT = JSON.parse(sessionStorage.getItem('EVENT'));
  const [deadline, setDeadline] = useState(
    EVT && EVT.sponsorDeadline ? EVT.sponsorDeadline : moment().format('YYYY-MM-DDTHH:mm').toString(),
  );

  let cols = [
    {
      name: 'id',
      label: 'No',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return tableMeta.tableData.length - tableMeta.rowIndex;
        },
      },
    },
    {
      name: 'id',
      label: '접수번호',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const _info = data[tableMeta.rowIndex];
          return (
            <span className={classes.link} onClick={(e) => setUpdateAction('read', value, tableMeta, updateValue)}>
              {value}
            </span>
          );
        },
      },
    },
    {
      name: 'applicationType',
      label: '구분',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,

        customBodyRender: (value) => {
          let val = value;
          if (value === 'Offline') val = '부스';
          if (value === 'Advertise') val = '광고';
          return val;
        },
      },
    },
    {
      name: 'name',
      label: '회사명 (국문)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
      },
    },
    {
      name: 'nameEn',
      label: '회사명 (영문)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'licenseNum',
      label: '사업자등록번호',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'createdAt',
      label: '등록일',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const dt = moment(Number(value));
          return dt.format('YYYY-MM-DD HH:mm:ss');
        },
      },
    },

    {
      name: 'ceo',
      label: '대표자',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,

        display: false,
      },
    },
    {
      name: 'address',
      label: '사업장소재지',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'adrDetail',
      label: '사업장소재지 상세주소',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
        download: false,
      },
    },
    {
      name: 'postalCode',
      label: '우편번호(사업장소재지)',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'manager',
      label: '담당자(이름)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'mRank',
      label: '담당자(직급)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        display: false,
      },
    },
    {
      // name: 'manager',
      name: 'id',
      label: '담당자(직급)',
      options: {
        filter: false,
        // sort: true,
        sort: false,
        viewColumns: false,
        download: false,

        display: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const item = data.find((f) => f.id === value);
          // const _info = data[tableMeta.rowIndex];
          return `${item.manager}  (${item.mRank})`;
        },
      },
    },
    {
      name: 'mobile',
      label: '담당자 HP',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,

        display: false,
      },
    },
    {
      name: 'mTel',
      label: '담당자(전화번호)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'mEmail',
      label: '담당자(이메일)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'grade',
      label: '신청내용',
      options: {
        filter: true,
        sort: true,
        viewColumns: false,

        display: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          let val = value;
          if (value === 'typeA') val = 'A Type';
          if (value === 'typeB') val = 'B Type';
          if (value === 'onlineAd') val = '온라인 광고';
          if (value === 'onlineBooth') val = '온라인 부스';
          return val;
        },
      },
    },
    {
      name: 'boothNo',
      label: '부스번호',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        // customBodyRender: (value, tableMeta, updateValue) => {
        //   let val = value;
        //   if (value === 'typeA') val = 'A Type';
        //   if (value === 'typeB') val = 'B Type';
        //   if (value === 'onlineAd') val = '온라인 광고';
        //   if (value === 'onlineBooth') val = '온라인 부스';
        //   return val;
        // },
      },
    },

    {
      name: 'table',
      label: '테이블 및 의자 신청',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,

        display: false,
        customBodyRender: (value) => {
          let val = value;
          if (value === true) val = '신청';
          if (value === false) val = '미신청';
          // if (value === 'onlineAd') val = '온라인 광고';
          // if (value === 'onlineBooth') val = '온라인 부스';
          return val;
        },
      },
    },
    {
      name: 'isAdd',
      label: '책자광고',
      options: {
        filter: true,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          let val = '';
          if (value === 'PB1') val = '프로그램 북 표1';
          if (value === 'PB2') val = '프로그램 북 표2';
          if (value === 'PB3') val = '프로그램 북 표3';
          if (value === 'PB4') val = '프로그램 북 표4';
          if (value === 'eBOOK') val = '초록집 광고';
          return val;
        },
      },
    },

    {
      name: 'abstractCount',
      label: '초록집내지광고(신청수)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
      },
    },

    {
      name: 'addPgmBookCount',
      label: '프로그램북광고(신청수)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
      },
    },
    {
      name: 'totalPrice',
      label: '총금액(VAT포함)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return addComma(value) + '';
        },
      },
    },
    {
      name: 'recipient',
      label: '세금계산서 수령인',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,

        display: false,
      },
    },
    {
      name: 'taxEmail',
      label: '발행 이메일',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,

        display: false,
      },
    },
    {
      name: 'taxDate',
      label: '발행 요청일',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,

        display: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return moment(value).format('YYYY-MM-DD');
        },
      },
    },
    {
      name: 'payCheckDate',
      label: '결제확인일',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
      },
    },
    {
      name: 'id',
      label: '입금상태',
      options: {
        filter: true,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const item = data.find((f) => f.id === value);
          return (
            <select value={item.status} onChange={(e) => handleStatus(e, updateValue, tableMeta, value)}>
              <option value={'Waiting for payment'}>Waiting for payment</option>
              <option value={'Completed'}>Completed</option>
            </select>
          );
        },
      },
    },
    {
      name: 'status',
      label: '입금상태',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
        // customBodyRender: (value, tableMeta, updateValue) => {
        //   const item = data.find((f) => f.id === value);
        //   return (
        //     <select value={item.status} onChange={(e) => handleStatus(e, updateValue, tableMeta, value)}>
        //       <option value={'Waiting for payment'}>Waiting for payment</option>
        //       <option value={'Completed'}>Completed</option>
        //     </select>
        //   );
        // },
      },
    },
    {
      name: 'item1',
      label: '전시 및 주 취급품목 1',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'item2',
      label: '전시 및 주 취급품목 2',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'item3',
      label: '전시 및 주 취급품목 3',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'id',
      label: 'Mail',
      options: {
        filter: false,
        sort: true,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Button
                color={'primary'}
                size={'small'}
                variant={'contained'}
                disableElevation
                onClick={(e) => sendEmail(value)}
                style={{ width: '120px', margin: 5 }}
              >
                resend
              </Button>
              <Button
                color={'primary'}
                size={'small'}
                variant={'contained'}
                disableElevation
                onClick={(e) => sendCompleteEmail(value)}
                style={{ width: '120px', margin: 5 }}
              >
                complete
              </Button>
            </>
          );
        },
      },
    },
    {
      name: 'id',
      label: '관리',
      options: {
        filter: false,
        sort: true,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const isDel = selectFilter === 'cancel';
          return (
            <div>
              <IconButton aria-label="update" onClick={() => setUpdateAction('modify', value, tableMeta, updateValue)}>
                <Create fontSize="small" />
              </IconButton>
              <IconButton
                aria-label="delete"
                //  onClick={() => setDeleteAction(tableMeta)}
                onClick={() => setDeleteAction(value)}
              >
                <Delete fontSize="small" />
              </IconButton>
            </div>
          );
        },
      },
    },
  ];

  const handleStatus = (e, updateValue, meta, value) => {
    const _val = e.target.value;
    swal({
      title: '입금상태를 변경하시겠습니까?',
      text: '',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const updateStatus = {
          evt: EVENT_ID,
          // boothId: data[meta.rowIndex].id,
          boothId: value,
          status: _val,
          statusCode: _val === 'Waiting for payment' ? 'W' : 'C',
          payCheckDate: _val === 'Waiting for payment' ? '' : moment().format('YYYY-MM-DD HH:mm:ss'),
        };
        axiosInstance.post(`${WEB_API}/sponsor/mod`, updateStatus).then((_result) => {
          // updateValue(_val);
          getSponsorData();
        });
      }
    });
  };

  const showPreview = (val) => {
    setOpenUrl(`/#/admin/paper/Preview?paperId=${val}`);
    if (open) {
      setOpen(false);
      setTimeout(function () {
        setOpen(true);
      }, 300);
    } else {
      setOpen(true);
    }
  };

  const setUpdateAction = (_mode, val, meta, updateVal) => {
    const item = data.find((f) => f.id === val);
    if (selectFilter === 'cancel') {
      swal({
        title: '선택한 항목을 복구하시겠습니까?',
        text: '',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          axiosInstance
            .put(`${WEB_API}/sponsor/restore`, {
              eventId: EVENT_ID,
              sponsorId: item.id,
            })
            .then((res) => {
              setSelectFilter('all');
              getSponsorData();
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
    } else {
      setMode(_mode);
      setSelectData(item);

      // setOpenUrl(`/#/sponsor/application?isPop=true?mode=modify?boothId=${val}`);
      if (open) {
        setOpen(false);
        setTimeout(function () {
          setOpen(true);
        }, 300);
      } else {
        setOpen(true);
      }
    }
  };

  const sendEmail = (val) => {
    console.log(val);
    setOpenUrlResend(`/#/admin/Resend?type=sponsor&id=${val}`);
    if (openResend) {
      setOpenResend(false);
      setTimeout(function () {
        setOpenResend(true);
      }, 300);
    } else {
      setOpenResend(true);
    }
  };

  const sendCompleteEmail = (val) => {
    console.log(val);
    setOpenUrlResend(`/#/admin/Resend?type=sponsorComplete&id=${val}`);
    if (openResend) {
      setOpenResend(false);
      setTimeout(function () {
        setOpenResend(true);
      }, 300);
    } else {
      setOpenResend(true);
    }
  };

  const setDeleteAction = (value) => {
    const item = data.find((f) => f.id === value);
    swal({
      title: '정말 삭제하시겠습니까?',
      // text: selectFilter === 'cancel' ? '삭제 후 복구할수 없습니다.' : '',
      // text: `${item.id}`,
      text: '삭제 후 복구할수 없습니다.',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        //즉시 삭제
        axiosInstance
          .delete(`${WEB_API}/sponsor/?eventId=${EVENT_ID}&boothId=${item.id}`)
          .then((res) => {
            getSponsorData();
            // handleFilter('cancel');
          })
          .catch((err) => {
            console.error(err);
          });

        // if (selectFilter === 'cancel') {
        //   axiosInstance
        //     .delete(`${WEB_API}/sponsor/?eventId=${EVENT_ID}&boothId=${data[meta.rowIndex].id}`)
        //     .then((res) => {
        //       getSponsorData();
        //       handleFilter('cancel');
        //     })
        //     .catch((err) => {
        //       console.error(err);
        //     });
        // } else {
        //   axiosInstance
        //     .put(`${WEB_API}/sponsor/del`, {
        //       eventId: EVENT_ID,
        //       sponsorId: data[meta.rowIndex].id,
        //     })
        //     .then((res) => {
        //       getSponsorData();
        //     })
        //     .catch((err) => {
        //       console.error(err);
        //     });
        // }
      }
    });
  };

  const theme = createTheme({
    overrides: {
      MUIDataTable: {
        responsiveScroll: {
          overflowX: 'auto',
        },
      },
    },
  });

  const options = {
    print: false,
    filterType: 'dropdown',
    viewColumns: false,
    downloadOptions: {
      filename: `sponsor_${moment().valueOf()}.xls`,
    },
    selectableRows: 'none',
    searchOpen: true,
    customSearch: (searchQuery, currentRow, columns) => {
      let isFound = false;
      data.map((member) => {
        if (member.id === currentRow[0]) {
          for (const [key, value] of Object.entries(member)) {
            if (typeof value === 'string') {
              const val = value.toLowerCase().replace(/ /gi, '').replace(/-/gi, '').replace(/\+/gi, '');
              const search = searchQuery.toLowerCase().replace(/ /gi, '').replace(/-/gi, '').replace(/\+/gi, '');
              if (val.indexOf(search) !== -1) isFound = true;
            }
          }
        }
      });
      return isFound;
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      // 항목별 엑셀 다운로드 변환
      const dt = columns.findIndex((d) => d.name === 'createdAt');
      const hp = columns.findIndex((d) => d.name === 'mobile');
      const tel = columns.findIndex((d) => d.name === 'mTel');
      const taxDate = columns.findIndex((d) => d.name === 'taxDate');
      const address = columns.findIndex((d) => d.name === 'address');
      const adrDetail = columns.findIndex((d) => d.name === 'adrDetail');
      // 변환 항목 추가
      const addname = columns.findIndex((d) => d.name === 'applicationType');
      const licenseNum = columns.findIndex((d) => d.name === 'licenseNum');
      const postalCode = columns.findIndex((d) => d.name === 'postalCode');
      const table = columns.findIndex((d) => d.name === 'table');

      let retVal = [];
      data.map((_d) => {
        console.log(_d, 'd');
        if (dt !== -1) {
          _d.data[dt] = moment(Number(_d.data[dt])).format('YYYY-MM-DD HH:mm');
        }
        if (taxDate !== -1) {
          _d.data[taxDate] = moment(_d.data[taxDate]).format('YYYY-MM-DD');
        }
        if (address !== -1) {
          _d.data[address] = _d.data[address] + ' ' + _d.data[adrDetail];
        }
        if (hp !== -1) {
          _d.data[hp] = "'" + _d.data[hp];
        }
        if (_d.data[addname] === 'Offline') {
          _d.data[addname] = '부스';
        }
        if (_d.data[addname] === 'Advertise') {
          _d.data[addname] = '광고';
        }
        if (_d.data[table] === true) {
          _d.data[table] = '신청';
        }
        if (tel !== -1) {
          _d.data[tel] = "'" + _d.data[tel];
        }
        if (licenseNum !== -1) {
          _d.data[licenseNum] = "'" + _d.data[licenseNum];
        }
        if (postalCode !== -1) {
          _d.data[postalCode] = "'" + _d.data[postalCode];
        }
        retVal.push(_d);
        return _d;
      });
      return '\uFEFF' + buildHead(columns) + buildBody(retVal);
    },
  };

  const getSponsorData = (_isDel) => {
    console.log('getSponsorData >>>');
    let url = `${WEB_API}/sponsor/list?eventId=${getEventId()}&limit=-1`;
    if (_isDel) url += '&isDel=true';
    axiosInstance.get(`${url}`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      const arrData = response.data.sort((a, b) => {
        return Number(b.createdAt) - Number(a.createdAt);
      });

      setData(arrData);
      setAllData(arrData);
      // setData(response.data);
      // if (!_isDel) {
      //   setAllData(response.data);
      // }
    });
  };

  const doSaveDeadline = () => {
    saveDeadline(deadline, 'sponsorDeadline');
  };

  useEffect(() => {
    getSponsorData();
  }, []);

  const handleClose = () => {
    getSponsorData();
    setOpen(false);
    setOpenChart(false);
  };

  const handleFilter = (_filter) => {
    setSelectFilter(_filter);
    if (_filter === 'all') {
      setData(alldata);
    } else {
      getSponsorData(true);
    }
  };

  const showChart = () => {
    setCount({
      online: 0,
      offline: 0,
      advertisement: 0,
      typeA: 0,
      typeB: 0,
      onlineBooth: 0,
      onlineAdvertisement: 0,
      pb1: 0,
      pb2: 0,
      pb3: 0,
      pb4: 0,
      pb5: 0,
      ebook: 0,
    });
    data.map((item) => {
      setCount((prevState) => ({
        ...count,
        online: item.applicationType === 'Online' ? prevState['online'] + 1 : prevState['online'],
        offline: item.applicationType === 'Offline' ? prevState['offline'] + 1 : prevState['offline'],
        advertisement: item.applicationType === 'Advertise' ? prevState['advertisement'] + 1 : prevState['advertisement'],
        typeA: item.grade === 'typeA' ? prevState['typeA'] + 1 : prevState['typeA'],
        typeB: item.grade === 'typeB' ? prevState['typeB'] + 1 : prevState['typeB'],
        onlineBooth: item.grade === 'onlineBooth' ? prevState['onlineBooth'] + 1 : prevState['onlineBooth'],
        onlineAdvertisement: item.grade === 'onlineAd' ? prevState['onlineAdvertisement'] + 1 : prevState['onlineAdvertisement'],
        pb1: item.isAdd === 'PB1' ? prevState['pb1'] + 1 : prevState['pb1'],
        pb2: item.isAdd === 'PB2' ? prevState['pb2'] + 1 : prevState['pb2'],
        pb3: item.isAdd === 'PB3' ? prevState['pb3'] + 1 : prevState['pb3'],
        pb4: item.isAdd === 'PB4' ? prevState['pb4'] + 1 : prevState['pb4'],
        pb5: item.isAdd === 'PB5' ? prevState['pb5'] + 1 : prevState['pb5'],
        ebook: item.isAdd === 'eBOOK' ? prevState['ebook'] + 1 : prevState['ebook'],
      }));
    });
    setOpenChart(true);
  };

  return (
    <Grid item xs={12}>
      <CssBaseline />
      <AdminTopbar MIdx={6} SIdx={0} />
      <Grid container alignItems={'stretch'} direction="column" style={{ padding: 16 }} className={classes.root}>
        <Grid item>
          <Grid container spacing={4} justifyContent={'flex-start'} alignItems={'center'}>
            <Grid item>
              <h1>Sponsor</h1>
            </Grid>
            <Grid item>
              <ButtonGroup color="primary" disableElevation>
                <Button variant={selectFilter === 'all' ? 'contained' : 'outlined'} onClick={() => handleFilter('all')}>
                  All Sponsor
                </Button>
                {/* <Button variant={selectFilter === 'cancel' ? 'contained' : 'outlined'} onClick={() => handleFilter('cancel')}>
                  Deleted
                </Button> */}
              </ButtonGroup>
            </Grid>
            <Grid item>
              <Grid container alignItems={'center'} justifyContent={'center'}>
                <Grid item>
                  <TextField
                    style={{ marginRight: 5 }}
                    id="datetime-local"
                    label="스폰서등록 마감 일시"
                    type="datetime-local"
                    defaultValue={deadline}
                    onChange={(e) => setDeadline(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item>
                  <Button color="secondary" variant={'outlined'} startIcon={<SaveIcon />} onClick={doSaveDeadline} disableElevation>
                    저장
                  </Button>
                </Grid>
                <Grid item style={{ marginLeft: 100 }}>
                  <Button
                    color="primary"
                    variant={'outlined'}
                    startIcon={<BarChart />}
                    onClick={() => history.push('/admin/sponsorStatus')}
                    disableElevation
                  >
                    통계
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          {/*<MuiThemeProvider theme={theme}>*/}
          <MUIDataTable
            title={''}
            data={data}
            columns={cols}
            options={options}
            components={{ TableToolbar: TableToolBarCustom, TableFilterList: TableFilterList }}
          />
          {/*</MuiThemeProvider>*/}
        </Grid>
      </Grid>
      <AdminFooter />
      {open ? (
        <Dialog
          open={open}
          fullWidth
          maxWidth={'lg'}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <ExhibiApplication
            mode={mode}
            infoData={selectData}
            boothId={selectData.id}
            isPop={true}
            isAdmin={true}
            handleClose={handleClose}
          />
        </Dialog>
      ) : null}
      {openResend ? (
        <Popout url={openUrlResend} title="PRS2022-ADMIN-SPONSORRESEND" onClosing={handleClose} options={{ width: 850, height: 800 }} />
      ) : null}
      {openChart && <SponsorStatistics count={count} openChart={openChart} handleClose={handleClose} />}
    </Grid>
  );
};

export default SponsorListPage;
